import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsUtils from '@netsapiens/netsapiens-js/dist/utils';

import * as actions from '../../../state';
// eslint-disable-next-line import/no-cycle
import store from '../../../store';

export default function* forgotLogin(event) {
  yield put(actions.showLoaderPage());

  const apiHash = yield select((state) => state.configs.apiHash);

  const { email } = event.payload;
  const { extension } = event.payload;

  try {
    // const params = {
    //   email,
    //   extension,
    //   apiHash,
    // };

    const decodedApiHash = nsUtils.encoding.base64Decode(apiHash);
    const clientId = decodedApiHash.split(':');

    const data = {
      object: 'email',
      action: 'create',
      subject: 'Your Login Recovery',
      template: 'forgotten_username_email.php',
      // eslint-disable-next-line no-restricted-globals
      app_uri: `${location.origin}/analytics`,
      recipient: email,
      client_id: clientId,
    };

    if (extension) data.user = extension;

    nsApi.post(data).then((res) => {
      if (res.sent) {
        store.dispatch(actions.loginFormSuccessMsg('An email has been sent to the specified address.'));
        store.dispatch(actions.showLoginFormPage());
      } else {
        store.dispatch(actions.loginFormErrorMsg(
          'There was a problem retrieving your account. Please contact your administrator.',
        ));
        store.dispatch(actions.showForgotLoginPage());
      }
    }).catch(() => {
      store.dispatch(actions.loginFormErrorMsg(
        'There was a problem retrieving your account. Please contact your administrator.',
      ));
      store.dispatch(actions.showForgotLoginPage());
    });
  } catch (err) {
    store.dispatch(actions.loginFormErrorMsg(
      'There was a problem retrieving your account. Please contact your administrator.',
    ));
    store.dispatch(actions.showForgotLoginPage());
  }
}
